import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {TopAppBarNavigationIcon as RmwcTopAppBarNavigationIcon} from '@rmwc/top-app-bar'
import '@rmwc/top-app-bar/styles'

const StyledRmwcTopAppBarNavigationIcon = styled(RmwcTopAppBarNavigationIcon)`
  &&& {
    color: var(--mdc-theme-on-primary);
  }
`

const TopAppBarNavigationIcon = ({children, ...otherProps}) => <StyledRmwcTopAppBarNavigationIcon {...otherProps}>{children}</StyledRmwcTopAppBarNavigationIcon>

TopAppBarNavigationIcon.propTypes = {
  children: PropTypes.any
}

export {TopAppBarNavigationIcon}
